import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  wrapper: {
    position: 'sticky',
    left: 0,
    flexShrink: 0,
    zIndex: 100,
    backgroundColor: theme.palette.background.paper,
  },
  legendTitle: {
    display: 'flex',
    position: 'sticky',
    top: 0,
    justifyContent: 'space-between',
    alignItems: 'end',
    zIndex: 10,
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    backgroundColor: theme.palette.background.paper,
    fontWeight: 700,
    paddingLeft: 5,
  },
  legendInnerElement: {
    boxShadow: `2px 2px 10px 0px ${theme.palette.grey[400]}`,
    minHeight: '100%',
  },
  legendInnerWrapper: {
    position: 'relative',
  },
  legendList: {
    overflow: 'visible !important',
    backgroundColor: theme.palette.background.paper,
    //backgroundColor: '#FF000011',
  },
  legendListItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: 'white',
    border: 'none',
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    padding: 0,
    paddingLeft: 5,
    fontSize: 'inherit',
    fontFamily: 'inherit',
    textAlign: 'left',
    // backgroundColor: '#0000FF33',

    '&:hover': {
      backgroundColor: theme.palette.grey[100],
    },
  },
  legendIcon: {
    color: theme.palette.primary.main,
    marginRight: 10,
  },
}));
